module.exports = __webpack_public_path__ + "img/check.9dc2afd6.jpg";